import React from "react";
import { Link, Outlet } from "react-router-dom";
import profile from "../../Assets/profile/profile1.jpg";

const Protfolio = () => {
  return (
    <div class="drawer drawer-mobile">
      <input id="my-drawer-2" type="checkbox" class="drawer-toggle" />
      <div class="drawer-content ">  
      <Outlet></Outlet>
        <label
          for="my-drawer-2"
          class="btn btn-square btn-ghost drawer-button lg:hidden"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            class="inline-block w-5 h-5 stroke-current"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6h16M4 12h16M4 18h16"
            ></path>
          </svg>
        </label>
      </div>
      <div class="drawer-side border-r-2">
        <label for="my-drawer-2" class="drawer-overlay "></label>
        <ul class="menu p-4 overflow-y-auto w-64 bg-neutral text-secondary ">
          {/* <!-- Sidebar content here --> */}
          <li>
            <div class="avatar">
              <div class="w-35 rounded-full ring ring-primary ring-offset-base-100 ring-offset-2">
                <img className="w-100 h-100" src={profile} />
              </div>
            </div>
          </li>
          <div class="border-t-2"></div>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About</Link>
            </li>
            <li>
              <Link to="/resume">Resume</Link>
            </li>
            <li>
              <Link to="/protfolios">Protfolios</Link>
            </li>
            <li>
              <Link to="/blogs">Blogs</Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
        </ul>
      </div>
     
    </div>
  );
};

export default Protfolio;
